import React from 'react';
import { observer } from 'mobx-react';
import { Dropdown, MenuProps, Tooltip } from 'antd';
import { BankOutlined, LogoutOutlined, NotificationOutlined, UserOutlined } from '@ant-design/icons';
import { useProfile, useRouterStore, useUiLanguage } from '../../hooks';
import { authLogOutUser, isAvailablePage } from '../../middleware';
import { tB, tP } from '../../translate';
import Styles from './m_styles.less';

export const ProfileMenu: React.FC = observer(() => {
    const { firstName, lastName, email, companyId } = useProfile();
    const languageId = useUiLanguage();
    const routerStore = useRouterStore();
    const isAvailableMenu = isAvailablePage('My');
    if (!isAvailableMenu) {
        return null;
    }
    const isProfile = isAvailablePage('Profile');
    const isMyCompany = isAvailablePage('MyCompany');
    const isMyAlarms = isAvailablePage('MyAlarms');

    const goTo = (routeName: string): void => {
        routerStore.goTo(routeName);
    };

    const goToCompany = (): void => {
        if (companyId) {
            routerStore.goTo('MyCompany');
        }
    };

    const items: MenuProps['items'] = [
        {
            label: `${firstName} ${lastName}`,
            key: 'name',
            disabled: true,
            isShow: true,
        },
        {
            label: email,
            key: 'email',
            disabled: true,
            isShow: true,
        },
        {
            key: 'divider 1',
            type: 'divider',
            isShow: true,
        },
        {
            label: tP('Profile'),
            key: 'profile',
            icon: <UserOutlined />,
            onClick: () => goTo('Profile'),
            isShow: isProfile,
        },
        {
            label: tP('My Company'),
            key: 'myCompany',
            icon: <BankOutlined />,
            onClick: goToCompany,
            isShow: isMyCompany,
        },
        {
            label: tP('My Alarms'),
            key: 'myAlarm',
            icon: <NotificationOutlined />,
            onClick: () => goTo('MyAlarms'),
            isShow: isMyAlarms,
        },
        {
            key: 'divider 2',
            type: 'divider',
            isShow: isProfile || isMyCompany || isMyAlarms,
        },
        {
            label: tP('Log out'),
            key: 'logOut',
            icon: <LogoutOutlined />,
            danger: true,
            onClick: authLogOutUser,
            isShow: true,
        },
    ]
        .filter((i) => i.isShow)
        .map((i) => {
            return {
                key: i.key,
                label: i.label,
                icon: i.icon,
                danger: i.danger,
                disabled: i.disabled,
                type: i.type,
                onClick: i.onClick,
            };
        });

    return (
        <>
            <Tooltip title={tB('Profile menu')} placement="bottomRight">
                <Dropdown menu={{ items }} trigger={['click']}>
                    <div className={Styles.avatarPlace} title={`${firstName} ${lastName}`} data-test="profileMenu">
                        <UserOutlined className={Styles.avatarIcon} />
                    </div>
                </Dropdown>
            </Tooltip>
        </>
    );
});
